import { Component, h, Prop, State } from '@stencil/core';
import rentwareIcon from '../../../types/icons';
import { CartIcon } from '../../../types/types';
import { capitalizeFirstLetter } from '../../../utils/utils';

@Component({
  tag: 'rentware-cart-control-button',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartControlButton {
  @Prop() onClick;
  @Prop() iconId: CartIcon;
  @Prop() total: number;
  @Prop() isLoading: boolean;
  @Prop() customCartIcon: CartIcon; // for preview

  @State() totalState: number = 0;
  @State() totalStyle = 'ItemsNumberContainer';
  @State() iconStyle = '';
  @State() rippleStyle = 'RippleContainer';

  componentWillRender() {
    if (this.total !== undefined && this.total !== this.totalState) {
      this.totalState = this.total;
      this.totalStyle = 'ItemsNumberContainer';
      this.iconStyle = '';
      this.rippleStyle = 'RippleContainer';

      setTimeout(() => {
        this.totalStyle = 'ItemsNumberContainer Animated';
        this.iconStyle = 'Animated';
        this.rippleStyle = 'RippleContainer Rippled';
      }, 0);
    }
  }

  get cartIcon() {
    if (this.customCartIcon) {
      return 'iconCart' + this.customCartIcon;
    } else {
      return 'iconCart' + capitalizeFirstLetter(this.iconId);
    }
  }

  render() {
    if (!this.iconId) {
      return null;
    }

    return (
      <div class={{ CollapsedButton: true, GlobalButtonPosition: true, Loading: this.isLoading }} onClick={this.onClick} tabIndex={0}>
        <div class={this.totalStyle}>{this.totalState}</div>

        <div class={this.iconStyle}>{rentwareIcon(this.cartIcon)}</div>

        <div class={this.rippleStyle} />
      </div>
    );
  }
}
